import {TakeTruffle} from './takeTruffle.model';

export class UserSignUp {
  id: string;
  salutation: string;
  firstName: string;
  lastname: string;
  email: string;
  address: string;
  city: string;
  postcode: string;
  phone: string;
  sponsoringSince: string;
  treeReferences: string[] = [];
  takeTruffle: TakeTruffle[] = [];
  password: string;
  passwordConfirm: string;
}
